// extracted by mini-css-extract-plugin
export default {"entityOption":"entityOption_entityOption__-nHuH","optionLabel":"entityOption_optionLabel__FB4mK","optionName":"entityOption_optionName__urtgO"};